<template>
    <panel-navigation>

      <div class="flex flex-row items-top justify-between">
        <h1 class="text-lg font-semibold mb-3">Reports</h1>
        <!-- <div class="bg-green-500 hover:bg-green-400 text-white inline-block rounded py-2 px-3 cursor-pointer" :class="{'spinner': saving}" @click="save">Save</div> -->
      </div>

      <b-row>
        <div class="flex flex-row flex-wrap mb-4 mt-4">
          <div v-if="isAccelerate()" class="dashboard-box stats-box w-full px-5 md:w-1/3 lg:w-1/3">
            <b-card body-class="text-center" header-tag="nav" style="border: 0px !important;">
              <b-card-text
                style="
                  font-weight: bolder;
                  height: 70px;
                  width: 70px;
                  border-radius: 50px;
                  background-color: rgba(68, 70, 143, 0.1);
                  margin: auto;
                  margin-bottom: 15px;
                "
              >
                <br />
                <!-- <file-text-icon
                  size="1.5x"
                  class="custom-class ml-21"
                  style="color: #44468f; margin-left: 22px"
                ></file-text-icon> -->
                <i class="mdi mdi-chart-tree" style="font-size: 22px;"></i>
              </b-card-text>
              <b-card-text style="font-weight: bolder">
                Roll Up Report
              </b-card-text>
              <button
                class="custom-bordered-button w-9/12"
                style="padding: 7px; border-radius: 5px"
                @click="$router.push('/roll-up-report')"
              >
                <span class="text-sm text-bold pt-1 text-center"
                  >
                  <i class="mdi mdi-logout" style="font-size: 16px;"></i>
                  VIEW REPORT</span
                >
              </button>
            </b-card>
          </div>

          <div v-if="!isAccelerate()" class="dashboard-box stats-box w-full px-5 md:w-1/3 lg:w-1/3">
            <b-card body-class="text-center" header-tag="nav" style="border: 0px !important;">
              <b-card-text
                style="
                  font-weight: bolder;
                  height: 70px;
                  width: 70px;
                  border-radius: 50px;
                  background-color: rgba(68, 70, 143, 0.1);
                  margin: auto;
                  margin-bottom: 15px;
                "
              >
                <br />
                <!-- <file-text-icon
                  size="1.5x"
                  class="custom-class ml-21"
                  style="color: #44468f; margin-left: 22px"
                ></file-text-icon> -->
                <i class="mdi mdi-chart-tree" style="font-size: 22px;"></i>
              </b-card-text>
              <b-card-text style="font-weight: bolder">
                Survey Report
              </b-card-text>
              <button
                class="custom-bordered-button w-9/12"
                style="padding: 7px; border-radius: 5px"
                @click="$router.push('/leads-public-survey')"
              >
                <span class="text-sm text-bold pt-1 text-center"
                  >
                  <i class="mdi mdi-logout" style="font-size: 16px;"></i>
                  VIEW REPORT</span
                >
              </button>
            </b-card>
          </div>
        </div>
      </b-row>
    </panel-navigation>
</template>

<script>
import { mapState } from "vuex";
import PanelNavigation from "@/components/PanelNavigation.vue";

export default {
  metaInfo() {
    return {
      title: "Agency Reports 1  | " + this.$appName,
    };
  },
  components: {
    PanelNavigation
  },
  data() {
    return {};
  },
  methods: {

    getHost() {
      return window.location.host;
    },

    isAccelerate() {
       // || this.getHost() == 'zany-space-palm-tree-q9vjg4xr39j97-8080.app.github.dev'
      return this.getHost() == 'lsa.accelerateyourmarketing.com';
    },
    
  },
  computed: {
    ...mapState({
      me: (state) => state.me.me,
      profile: (state) => state.me.profile,
    }),
  },
  created() {
    this.$store.dispatch("me/fetch");
  },
};
</script>

<style scoped></style>
